export const faqs = [
  {
    q: '糖心吃瓜主要收录哪些内容？',
    a: '网站围绕互联网上的玩梗现场展开，重点收录热评、弹幕、名场面、群聊高能片段和接梗合集。所有内容都以“现场感”为核心整理，方便你快速看到最热闹的那几段。',
  },
  {
    q: '页面上的热度、评论数和弹幕数是怎么来的？',
    a: '热度、评论数和弹幕数是根据一段内容在站内的浏览、互动和转发情况综合计算出的参考值，用来帮你判断哪几段最值得先看，并不代表任何官方统计口径。',
  },
  {
    q: '我想投稿自己刷到的玩梗现场，可以吗？',
    a: '当然可以。你可以通过“联系我们”页面的表单提交线索，简单描述一下是什么类型的场面、大概发生了什么，并留下联系方式。我们会认真阅读每一条投稿。',
  },
  {
    q: '网站上的名场面会持续更新吗？',
    a: '会。热榜每天都会根据站内互动情况重新排序，名场面与热评精选也会定期补充新的条目。部分旧条目会被整理进对应分类，方便你按主题翻看。',
  },
  {
    q: '为什么有些内容点进去之后和标题讲的不太一样？',
    a: '我们的标题会尽量还原现场那一句话的感觉，而正文会补充前因后果。如果你觉得某段内容与标题偏差较大，欢迎反馈，我们会重新校订。',
  },
  {
    q: '可以按分类只浏览自己感兴趣的内容吗？',
    a: '可以。进入“话题分类”页面后，你可以通过顶部的分类标签切换，也可以直接使用搜索框按关键词查找想看的玩梗现场。',
  },
  {
    q: '网站会收集我的个人信息吗？',
    a: '浏览网站不需要注册，也不会要求你提供个人信息。只有在你主动填写投稿或合作表单时，我们才会收到你留下的联系方式。',
  },
  {
    q: '内容可以转载或引用吗？',
    a: '站内原创的整理文字欢迎在注明来源的前提下少量引用。涉及网友的具体评论与创作内容，请尊重原作者的意愿，避免用于商业用途。',
  },
];